import ProgramStrategisCard from "@/app/Components/ProgramStrategisCard";
import React from "react";
import { motion } from "framer-motion";

const ProgramStrategis = () => {
  const dataDummy = [
    {
      title: "SAPA UMKM",
      image: "/image/ProgramStrategis1.webp",
    },
    {
      title: "Kartu Usaha",
      image: "/image/ProgramStrategis2.webp",
    },
    {
      title: "Holding UMKM",
      image: "/image/ProgramStrategis3.webp",
    },
    {
      title: "Penghapusan Piutang UMKM",
      image: "/image/ProgramStrategis4.webp",
    },
    {
      title: "Keterlibatan UMKM Dalam Program Makan Bergizi Gratis",
      image: "/image/ProgramStrategis5.webp",
    },
    {
      title: "Business Matching",
      image: "/image/ProgramStrategis6.webp",
    },
    {
      title: "Perluasan Akses Pembiayaan dan Investasi",
      image: "/image/ProgramStrategis7.webp",
    },
    {
      title: "Enterpreneur Hub",
      image: "/image/ProgramStrategis8.webp",
    },
    {
      title: "Layanan Pendampingan dan Konsultasi Usaha yang Terintegrasi",
      image: "/image/ProgramStrategis9.webp",
    },
    {
      title: "Transformasi Usaha",
      image: "/image/ProgramStrategis10.webp",
    },
  ];

  return (
    <div className="flex flex-col justify-center items-center w-full gap-5 md:gap-10 px-5 sm:px-10 md:px-16 overflow-hidden">
      <motion.div
        className="w-full text-2xl sm:text-4xl lg:text-5xl font-bold text-cust-blue leading-tight text-center md:text-left"
        initial={{ x: 50, opacity: 0 }}
        whileInView={{
          x: 0,
          opacity: 1,
        }}
        transition={{
          duration: 0.5,
          delay: 1,
          ease: "easeInOut",
        }}
        viewport={{ once: true }}
      >
        Program Strategis: <br />
        Pengembangan UMKM dan Kewirausahaan
      </motion.div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 xl:grid-cols-5 gap-5">
        {dataDummy.map((data, index) => {
          const isLast = index === dataDummy.length - 1;
          const colSpanClass = isLast
            ? "col-span-1 lg:col-span-6 xl:col-span-1"
            : "col-span-1 lg:col-span-2 xl:col-span-1";

          return (
            <div key={index} className={colSpanClass}>
              <ProgramStrategisCard data={data} index={index} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProgramStrategis;
